import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgForgotPasswordBlue = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 52,
	height: 52,
	viewBox: "0 0 52 52",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M29.2019 25.959C30.9941 25.959 32.4467 24.5063 32.4467 22.7141C32.4467 20.9219 30.9941 19.4692 29.2019 19.4692C27.4097 19.4692 25.957 20.9219 25.957 22.7141C25.957 24.5063 27.4097 25.959 29.2019 25.959Z",
		fill: "#659DFF"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M36.8356 0H15.0821C5.63307 0 0 5.63307 0 15.0821V36.8097C0 46.2847 5.63307 51.9177 15.0821 51.9177H36.8097C46.2587 51.9177 51.8918 46.2847 51.8918 36.8356V15.0821C51.9177 5.63307 46.2847 0 36.8356 0ZM36.0569 29.7748C33.3831 32.4226 29.5671 33.2533 26.1925 32.189L23.4409 34.9147C23.2072 35.1483 22.7919 35.1483 22.5323 34.9147L20.0143 32.3967C19.6509 32.0332 19.0278 32.0332 18.6385 32.3967C18.2491 32.7601 18.275 33.3831 18.6385 33.7725L21.1565 36.2905C21.4161 36.5501 21.4161 36.9654 21.1565 37.1991L20.0922 38.2634C19.6509 38.7306 18.7942 39.0162 18.1712 38.9383L15.3417 38.5489C14.4072 38.4191 13.5505 37.5365 13.3948 36.602L13.0054 33.7725C12.9016 33.1495 13.2131 32.2928 13.6284 31.8515L19.7287 25.7512C18.6904 22.3765 19.4951 18.5606 22.1689 15.8868C25.9848 12.0709 32.215 12.0709 36.0569 15.8868C39.8988 19.7028 39.8988 25.9329 36.0569 29.7748Z",
		fill: "#659DFF"
	})]
});
export default SvgForgotPasswordBlue;
